// @flow
import * as React from "react";

export default function WithNavigation(props) {
  React.useLayoutEffect(() => {
      props.onChangeCurrentPath(props.value)
  }, [props.history.location.pathname]);
  return <>{props.children}</>;
}
